module.exports = __webpack_public_path__ + "img/guangdong.ca12296d.png";